import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    $.uf.dropzoneS3(".dropzone-target", ".dropzone-template", ".dropzone-previews", "/message_attachments/", { maxFiles: 10, clickable: ".fileinput-button" });
  }

}